// Self-contained ICAO airline callsign lookup.
// Keys are 3-letter ICAO airline designators (the prefix of a flight callsign,
// e.g. "BAW123" -> "BAW"). Values include the airline name, country, and the
// spoken radio callsign word used on the radio (e.g. "Speedbird").

export const AIRLINES = {
  BAW: { name: "British Airways", country: "United Kingdom", callsignWord: "Speedbird" },
  UAL: { name: "United Airlines", country: "United States", callsignWord: "United" },
  AAL: { name: "American Airlines", country: "United States", callsignWord: "American" },
  DAL: { name: "Delta Air Lines", country: "United States", callsignWord: "Delta" },
  SWA: { name: "Southwest Airlines", country: "United States", callsignWord: "Southwest" },
  RYR: { name: "Ryanair", country: "Ireland", callsignWord: "Ryanair" },
  EZY: { name: "easyJet", country: "United Kingdom", callsignWord: "Easy" },
  DLH: { name: "Lufthansa", country: "Germany", callsignWord: "Lufthansa" },
  AFR: { name: "Air France", country: "France", callsignWord: "Airfrans" },
  KLM: { name: "KLM Royal Dutch Airlines", country: "Netherlands", callsignWord: "KLM" },
  UAE: { name: "Emirates", country: "United Arab Emirates", callsignWord: "Emirates" },
  QTR: { name: "Qatar Airways", country: "Qatar", callsignWord: "Qatari" },
  SIA: { name: "Singapore Airlines", country: "Singapore", callsignWord: "Singapore" },
  QFA: { name: "Qantas", country: "Australia", callsignWord: "Qantas" },
  ACA: { name: "Air Canada", country: "Canada", callsignWord: "Air Canada" },
  WJA: { name: "WestJet", country: "Canada", callsignWord: "Westjet" },
  JBU: { name: "JetBlue Airways", country: "United States", callsignWord: "JetBlue" },
  VIR: { name: "Virgin Atlantic", country: "United Kingdom", callsignWord: "Virgin" },
  IBE: { name: "Iberia", country: "Spain", callsignWord: "Iberia" },
  VLG: { name: "Vueling", country: "Spain", callsignWord: "Vueling" },
  EIN: { name: "Aer Lingus", country: "Ireland", callsignWord: "Shamrock" },
  TAP: { name: "TAP Air Portugal", country: "Portugal", callsignWord: "Air Portugal" },
  SAS: { name: "Scandinavian Airlines", country: "Sweden", callsignWord: "Scandinavian" },
  FIN: { name: "Finnair", country: "Finland", callsignWord: "Finnair" },
  AUA: { name: "Austrian Airlines", country: "Austria", callsignWord: "Austrian" },
  SWR: { name: "Swiss International Air Lines", country: "Switzerland", callsignWord: "Swiss" },
  THY: { name: "Turkish Airlines", country: "Turkey", callsignWord: "Turkish" },
  ETD: { name: "Etihad Airways", country: "United Arab Emirates", callsignWord: "Etihad" },
  ANA: { name: "All Nippon Airways", country: "Japan", callsignWord: "All Nippon" },
  JAL: { name: "Japan Airlines", country: "Japan", callsignWord: "Japan Air" },
  CCA: { name: "Air China", country: "China", callsignWord: "Air China" },
  CES: { name: "China Eastern Airlines", country: "China", callsignWord: "China Eastern" },
  CSN: { name: "China Southern Airlines", country: "China", callsignWord: "China Southern" },
  CPA: { name: "Cathay Pacific", country: "Hong Kong", callsignWord: "Cathay" },
  KAL: { name: "Korean Air", country: "South Korea", callsignWord: "Korean Air" },
  AAR: { name: "Asiana Airlines", country: "South Korea", callsignWord: "Asiana" },
  THA: { name: "Thai Airways", country: "Thailand", callsignWord: "Thai" },
  MAS: { name: "Malaysia Airlines", country: "Malaysia", callsignWord: "Malaysian" },
  GIA: { name: "Garuda Indonesia", country: "Indonesia", callsignWord: "Indonesia" },
  AIC: { name: "Air India", country: "India", callsignWord: "Air India" },
  SVA: { name: "Saudia", country: "Saudi Arabia", callsignWord: "Saudia" },
  ELY: { name: "El Al", country: "Israel", callsignWord: "El Al" },
  ROT: { name: "Tarom", country: "Romania", callsignWord: "Tarom" },
  LOT: { name: "LOT Polish Airlines", country: "Poland", callsignWord: "Lot" },
  CSA: { name: "Czech Airlines", country: "Czech Republic", callsignWord: "CSA Lines" },
  WZZ: { name: "Wizz Air", country: "Hungary", callsignWord: "Wizz Air" },
  NAX: { name: "Norwegian Air Shuttle", country: "Norway", callsignWord: "Nor Shuttle" },
  ICE: { name: "Icelandair", country: "Iceland", callsignWord: "Iceair" },
  TVS: { name: "Smartwings", country: "Czech Republic", callsignWord: "Skytravel" },
  VOI: { name: "Volaris", country: "Mexico", callsignWord: "Volaris" },
  AMX: { name: "Aeroméxico", country: "Mexico", callsignWord: "Aeromexico" },
  TAM: { name: "LATAM Airlines", country: "Brazil", callsignWord: "Tam" },
  GLO: { name: "Gol Linhas Aéreas", country: "Brazil", callsignWord: "Gol Transporte" },
  AZU: { name: "Azul Brazilian Airlines", country: "Brazil", callsignWord: "Azul" },
  AVA: { name: "Avianca", country: "Colombia", callsignWord: "Avianca" },
  ABX: { name: "ABX Air", country: "United States", callsignWord: "Abex" },
  FDX: { name: "FedEx Express", country: "United States", callsignWord: "FedEx" },
  UPS: { name: "UPS Airlines", country: "United States", callsignWord: "UPS" },
  GTI: { name: "Atlas Air", country: "United States", callsignWord: "Giant" },
  BOX: { name: "AeroLogic", country: "Germany", callsignWord: "German Cargo" },
  ETH: { name: "Ethiopian Airlines", country: "Ethiopia", callsignWord: "Ethiopian" },
  MEA: { name: "Middle East Airlines", country: "Lebanon", callsignWord: "Cedar Jet" },
  GFA: { name: "Gulf Air", country: "Bahrain", callsignWord: "Gulf Air" },
  QLR: { name: "Qatar Executive", country: "Qatar", callsignWord: "Qatar Jet" },
  KQA: { name: "Kenya Airways", country: "Kenya", callsignWord: "Kenya" },
};

/**
 * Look up the airline for a flight callsign by its first 3 letters.
 * @param {string} callsign e.g. "BAW123"
 * @returns {{name:string,country:string,callsignWord:string}|null}
 */
export function airlineFromCallsign(callsign) {
  if (!callsign || typeof callsign !== "string") return null;
  const prefix = callsign.trim().slice(0, 3).toUpperCase();
  if (prefix.length < 3) return null;
  return AIRLINES[prefix] || null;
}
